import React, { useState } from 'react';
import Slide from './Slide';

type SlideType = {
  key: React.Key;
  content: React.ReactNode;
};

type VerticalCarouselProps = {
  slides: SlideType[];
  offsetRadius: number;
  animationConfig?: {
    tension: number;
    friction: number;
  };
};

const defaultAnimationConfig = {
  tension: 10,
  friction: 1,
};

function mod(a: number, b: number): number {
  return ((a % b) + b) % b;
}

const VerticalCarousel: React.FC<VerticalCarouselProps> = ({
  slides,
  offsetRadius,
  animationConfig = defaultAnimationConfig,
}) => {
  const [index, setIndex] = useState(0);

  const modBySlidesLength = (i: number) => mod(i, slides.length);

  const moveSlide = (direction: number) => {
    setIndex((prevIndex) => modBySlidesLength(prevIndex + direction));
  };

  const clampOffsetRadius = (radius: number) => {
    const upperBound = Math.floor((slides.length - 1) / 2);

    return Math.max(0, Math.min(radius, upperBound));
  };

  const getPresentableSlides = () => {
    const clampedRadius = clampOffsetRadius(offsetRadius);
    const presentable: SlideType[] = [];

    for (let i = -clampedRadius; i <= clampedRadius; i++) {
      presentable.push(slides[modBySlidesLength(index + i)]);
    }

    return presentable;
  };

  return (
    <div className="vertical-carousel">
      <div className="slide-header">
        <h2>
          Your Complete<span> Strategy Toolkit</span>
        </h2>
      </div>
      <div className="slide-wrapper">
        {getPresentableSlides().map((slide, presentableIndex) => (
          <Slide
            key={slide.key}
            content={slide.content}
            moveSlide={moveSlide}
            offsetRadius={clampOffsetRadius(offsetRadius)}
            index={presentableIndex}
            animationConfig={animationConfig}
          />
        ))}
      </div>

      {/* Navigation */}
      <div className="navigation-buttons">
        <div className="button" onClick={() => moveSlide(-1)}>
          <i className="fa-regular fa-angle-left" />
        </div>
        <div className="count-circle">
          {index + 1} / {slides.length}
        </div>
        <div className="button" onClick={() => moveSlide(1)}>
          <i className="fa-regular fa-angle-right" />
        </div>
      </div>
    </div>
  );
};

export default VerticalCarousel;
